import React from "react"

import FormToggle from "../../../../../../core/gd-form/form-element/toggle-new/toggle"

type Props = {
    option: Option
}

export default function PageSettingsMenuOption(props:Props) {
    return (
        <div className={Classes("option fl-jsb", {
            disabled: props.option.disabled
        })}>
            <div className="label">{props.option.label}</div>
            <FormToggle size        = "18"
                        value       = {props.option.value}
                        disabled    = {props.option.disabled}
                        onChange    = {props.option.onClick}/>

        </div>
    )
}